import { __DepositMethodsEnum } from './deposit.interface';

export const DepositMethods = [
    { title: 'واریز خودکار', key: __DepositMethodsEnum.cardToCard },
    { title: 'واریز درگاهی', key: __DepositMethodsEnum.direct },
    { title: 'واریز شناسه دار', key: __DepositMethodsEnum.cashInDeposit },
    { title: 'واریز با فیش بانکی', key: __DepositMethodsEnum.offlineDeposit },
];
